// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notificationWrapper{position:fixed;top:10px;right:10px;z-index:99999}.infoText{width:100%;clear:both;display:block}.infoText.listDecoration{display:list-item;width:calc(100% - 15px);position:relative;left:15px}.infoText.listDecoration:last-of-type{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
